import React, {useContext, useEffect, useMemo, useState} from 'react';
import classNames from "classnames";
import {generateIcon, iconMap} from "../../utils/constants";
import {Link, useNavigate} from "react-router-dom";
import Expander from "../common/Expander/Expander";
import {Context} from "../../main";
import Input from "../common/Input/Input";
import Button from "../common/Button/Button";
import {MODULE_GROUP_TABS, partitionMenuByGroup} from "../../utils/moduleGroup";

const searchIcon = generateIcon(iconMap.search, 'input-icon')
const exitIcon = generateIcon(iconMap.exit)

const Menu = ({menu, isSearch = false, activeKey, selectedKey, onClick}) => {
    const [search, setSearch] = useState('')
    const [groupTab, setGroupTab] = useState(null)
    const navigate = useNavigate()
    const {store} = useContext(Context)

    const grouped = useMemo(
        () => partitionMenuByGroup(Array.isArray(menu) ? menu : []),
        [menu],
    )
    const tabs = useMemo(
        () => MODULE_GROUP_TABS.filter((tab) => grouped[tab.id].length > 0),
        [grouped],
    )

    const selectedModule = useMemo(() => {
        if (!Array.isArray(menu)) return null
        return menu.find((item) => item?.children?.some((child) => child.key === selectedKey)) || null
    }, [menu, selectedKey])

    useEffect(() => {
        const group = selectedModule?.module_group
        if (group === 'kindergarten' || group === 'school') setGroupTab(group)
    }, [selectedModule])

    useEffect(() => {
        if (groupTab && !tabs.some((tab) => tab.id === groupTab)) {
            setGroupTab(null)
        }
    }, [tabs, groupTab])

    const showMenuItems = useMemo(() => {
        if (!search) return null
        const result = []
        if (Array.isArray(menu)) {
            menu.map(element => element?.children?.map(items => {
                if (items?.module_name?.toLowerCase()?.includes(search)) result.push(items)
                return element;
            }))
        }
        return result
    }, [search, menu])

    const selected = selectedModule?.module_id ?? null

    const renderExpanders = (items) => items.map((element) => (
        <Expander
            label={element.module_name}
            key={element.module_id || element.key}
            value={element.key}
            icon={element.icon}
            subMenuItem={element.children}
            onClick={onClick}
            activeKey={activeKey}
            selectedKey={selected === element.module_id}
        />
    ))

    const toggleGroup = (id) => {
        setGroupTab((current) => (current === id ? null : id))
    }

    return (
        <>
            <div className="header__nav-top">
                <Link to="/profile" className="paragraph paragraph--lg header__nav-name" onClick={onClick}>
                    {store.user?.fullName}
                </Link>
                <Button
                    className="btn btn--secondary header__nav-exit"
                    icon={exitIcon}
                    onClick={async () => {
                        await store.logout()
                        navigate('/')
                    }}
                />
            </div>
            {isSearch && (
                <Input
                    name={"search_input"}
                    icon={searchIcon}
                    type="text"
                    value={search}
                    placeholder="Пошук меню"
                    className="header__nav-search"
                    onChange={(_, value) => setSearch(value)}
                />
            )}
            {search ? (
                Array.isArray(showMenuItems) && showMenuItems.map((element, index) => (
                    <Expander
                        label={element.module_name}
                        key={element.key || index}
                        value={element.key}
                        icon={element.icon}
                        subMenuItem={element.children}
                        onClick={onClick}
                        activeKey={activeKey}
                        selectedKey={selected === element.module_id}
                    />
                ))
            ) : (
                <>
                    {renderExpanders(grouped.common)}
                    {tabs.map((tab) => {
                        const isOpen = groupTab === tab.id
                        return (
                            <div className="header__nav-group-block" key={tab.id}>
                                <button
                                    type="button"
                                    aria-expanded={isOpen}
                                    className={classNames('header__nav-group', {
                                        'header__nav-group--active': isOpen,
                                    })}
                                    onClick={() => toggleGroup(tab.id)}
                                >
                                    {tab.label}
                                </button>
                                {isOpen && (
                                    <div className="header__nav-group-panel">
                                        {renderExpanders(grouped[tab.id])}
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </>
            )}
        </>
    );
};

export default React.memo(Menu);
